import config from '../config.js'

export default {
    buildReadUrl: function (controller, command) {
        return [config.uris.public, controller + '/' + command].join('');
    },

    buildWriteUrl: function (controller, command) {
        controller = '' + controller + '/';
        return [config.uris.crud, controller, command].join('');
    },

    buildMwfUrl: function (controller, command) {
        controller = '/api/' + controller + '/';
        return [config.uris.crud, controller, command].join('');
    }
};
